import React, { Component } from 'react';
import Tooltip from '@material-ui/core/Tooltip';

export class LongTextCell extends Component {
    render(){
        return (
            <Tooltip title={(this.props.value ? this.props.value : '')}>
                <span className={'long-text'}>{this.props.value}</span>
            </Tooltip>
    
        )
    }
}

const bussinessConfig = {
    HTTP_CONFIG:{
        baseUrl:'/shared-base-data/basic/v1',
        // baseUrl:'',
    },
    GRID_CELL_WIDTH:{
        veryShort:60,short:100,lessMedium:140,medium:160,long:200,veryLong:240
    }
}


export default bussinessConfig;
export const GRID_CELL_WIDTH = bussinessConfig.GRID_CELL_WIDTH;
export const HTTP_CONFIG = bussinessConfig.HTTP_CONFIG;